import { render, staticRenderFns } from "./popup-remark-add.vue?vue&type=template&id=34174b34&scoped=true"
import script from "./popup-remark-add.vue?vue&type=script&lang=js"
export * from "./popup-remark-add.vue?vue&type=script&lang=js"
import style0 from "./popup-remark-add.vue?vue&type=style&index=0&id=34174b34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34174b34",
  null
  
)

export default component.exports